import { render, staticRenderFns } from "./ConfirmTournament.vue?vue&type=template&id=2565b214&"
import script from "./ConfirmTournament.vue?vue&type=script&lang=js&"
export * from "./ConfirmTournament.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmTournament.vue?vue&type=style&index=0&id=2565b214&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports